import { createActions } from 'reflux';
import { getIndicatorList } from '../api';

const indicatorsListActions = createActions({
  loadData: {},
  loadProgress: {},
  loadDataCompleted: {},
  loadDataFailed: {},
});


// SIDE-EFFECT: xhr request is triggered on FundingInfoActions.load()
indicatorsListActions.loadData.listen(() => {
  getIndicatorList(indicatorsListActions.loadProgress)
    .then(indicatorsListActions.loadDataCompleted)
    .catch(indicatorsListActions.loadDataFailed);
});

export default indicatorsListActions;



/** WEBPACK FOOTER **
 ** ./app/scripts/actions/indicatorslist.es6
 **/